(() => {
  class AVDTopBar {
    constructor(root) {
      this.root = root;
      this.items = [...root.querySelectorAll('[data-avd-top-bar-item]')];
      this.interval = Number(root.dataset.interval || 4000);
      this.activeIndex = Math.max(0, this.items.findIndex((item) => item.classList.contains('is-active')));
      this.timer = null;
      this.start();
    }

    start() {
      this.stop();
      if (this.items.length < 2 || this.interval < 1000) return;
      this.timer = window.setInterval(() => this.show(this.activeIndex + 1), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    show(index) {
      if (!this.items.length) return;
      this.activeIndex = (index + this.items.length) % this.items.length;
      this.items.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === this.activeIndex);
        item.setAttribute('aria-hidden', itemIndex === this.activeIndex ? 'false' : 'true');
      });
    }

    selectBlock(blockId) {
      const index = this.items.findIndex((item) => item.dataset.blockId === blockId);
      if (index === -1) return;
      this.stop();
      this.show(index);
    }
  }

  const init = () => {
    document.querySelectorAll('[data-avd-top-bar]').forEach((root) => {
      root.avdTopBar && root.avdTopBar.stop();
      root.avdTopBar = new AVDTopBar(root);
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest('[data-avd-top-bar]');
    if (root && root.avdTopBar) root.avdTopBar.selectBlock(event.detail.blockId);
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    const root = event.target.closest('[data-avd-top-bar]');
    if (root && root.avdTopBar) root.avdTopBar.start();
  });
})();
